// extracted by mini-css-extract-plugin
export default {"flexWrap":"TimerModal_flexWrap_AXgyt","timer":"TimerModal_timer_ooCVi"};